<template>
  <div class="parallax-node image" :parallax-child="depth">
    <img :src="src" :width="width" />
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
class ParallaxImage extends Vue {
  @Prop(String) src;
  @Prop({ type: [String, Number], default: '' })
  width;
  @Prop({
    type: [String, Number],
    default: 0
  })
  depth;
  @Prop(String) boundsElemId;
}

export default ParallaxImage;
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/ParallaxImage.vue